import React from 'react';
import { Box } from '@mui/material';
import { getSessionPatientIdLabel } from '../utils/sessionHistoryPatientDisplay';

export default function SessionPatientIdLabel({ session }) {
  const label = getSessionPatientIdLabel(session);
  if (!label) return null;

  return (
    <Box
      sx={{
        width: 24,
        height: 24,
        borderRadius: '50%',
        bgcolor: 'primary.main',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: label.length > 1 ? '0.58rem' : '0.65rem',
        fontWeight: 'bold',
        flexShrink: 0,
      }}
    >
      {label}
    </Box>
  );
}
